export default __webpack_public_path__ + "files/media/logo.react.a78bd26d.svg";